var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg012Buy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6H18V4.38C18 2.51328 16.4868 1 14.62 1H9.38004C7.51332 1 6.00004 2.51328 6.00004 4.38V6H3.00004C2.44776 6 2.00004 6.44772 2.00004 7V11C1.9951 11.0365 1.9951 11.0735 2.00004 11.11L2.79004 18.24C2.96375 19.8143 4.29622 21.0044 5.88004 21H18.12C19.7 20.9993 21.0268 19.8105 21.2 18.24L22 11.11C22.005 11.0735 22.005 11.0365 22 11V7C22 6.44772 21.5523 6 21 6ZM8.00004 4.38C8.00004 4.014 8.14544 3.66299 8.40424 3.40419C8.66304 3.14539 9.01405 3 9.38004 3H14.62C15.3822 3 16 3.61785 16 4.38V6H8.00004V4.38ZM19.21 18C19.1631 18.5666 18.6886 19.0019 18.12 19H5.88004C5.31152 19.0019 4.83698 18.5666 4.79004 18L4.12004 12H19.88L19.21 18ZM20 10H4.00004V8H20V10Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg012Buy);
export default __webpack_public_path__ + "static/media/012-buy.5bf22d499ad3989b440717965a876dbb.svg";
export { ForwardRef as ReactComponent };